import React from "react";
import {
  Box,
  Container,
  Text,
  useColorMode,
  Grid,
  GridItem,
  Image,
  Link,
  VStack,
  HStack,
  Heading,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FiCode,
  FiCpu,
  FiDollarSign,
  FiFile,
  FiHelpCircle,
  FiHome,
  FiList,
  FiMail,
  FiMessageSquare,
  FiPhone,
  FiPhoneCall,
  FiShoppingCart,
  FiTarget,
} from "react-icons/fi";
import {
  FaFilePdf,
  FaGithub,
  FaHandMiddleFinger,
  FaMicroblog,
  FaTable,
} from "react-icons/fa";

export const Footer: React.FC = () => {
  const { colorMode } = useColorMode();
  const { t } = useTranslation();

  return (
    <Box
      as="footer"
      py={8}
      // position="fixed"
      // bottom={0}
      // left={0}
      // right={0}
      // zIndex={1000}
      bg={colorMode === "dark" ? "gray.900" : "white"}
      borderTop="1px"
      borderColor={colorMode === "dark" ? "gray.700" : "gray.200"}>
      <Container maxW="container.xl">
        <Grid templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }} gap={8}>
          {/* Logo & About Column */}
          <GridItem>
            <VStack align="flex-start" spacing={4}>
              <Image
                src={`/assets/img/logo-hor-${
                  colorMode === "dark" ? "dark" : "light"
                }.svg`}
                alt="Logo"
                h="40px"
                w="auto"
              />
              <Text
                fontSize="sm"
                color={colorMode === "dark" ? "gray.400" : "gray.600"}>
                {t("common.footer.about")}
              </Text>
            </VStack>
          </GridItem>

          {/* Products Column */}
          <GridItem>
            <VStack align="flex-start" spacing={3} fontFamily="heading">
              <Heading size="md" fontWeight="bold" mb={2}>
                {t("common.footer.products")}
              </Heading>

              <Link
                as={RouterLink}
                to="/pricing"
                display="flex"
                alignItems="center"
                gap={2}>
                <FiDollarSign />
                {t("common.footer.arariaPlans")}
              </Link>
              <Link
                as={RouterLink}
                to="/nuvemshop"
                display="flex"
                alignItems="center"
                gap={2}>
                <FiShoppingCart />
                {t("common.footer.nuvemshop", "Nuvem Shop")}
              </Link>
              <Link
                as={RouterLink}
                to="/chat-agents"
                display="flex"
                alignItems="center"
                gap={2}>
                <FiCpu />
                {t("common.footer.agents", "Agentes de Chat")}
              </Link>
              <Link
                as={RouterLink}
                to="/models"
                display="flex"
                alignItems="center"
                gap={2}>
                <FaTable />
                {t("common.footer.models")}
              </Link>
            </VStack>
          </GridItem>
          {/* Menu Column */}
          <GridItem>
            <VStack align="flex-start" spacing={3} fontFamily="heading">
              <Heading size="md" fontWeight="bold" mb={2}>
                {t("common.footer.menu")}
              </Heading>
              <Link
                as={RouterLink}
                to="/"
                display="flex"
                alignItems="center"
                gap={2}>
                <FiHome />
                {t("common.footer.home")}
              </Link>
              <Link
                as={RouterLink}
                to="/features"
                display="flex"
                alignItems="center"
                gap={2}>
                <FiTarget />
                {t("common.footer.featureRequest")}
              </Link>
              <Link
                as={RouterLink}
                to="/contact"
                display="flex"
                alignItems="center"
                gap={2}>
                <FiMail />
                {t("common.footer.contact")}
              </Link>
              <Link
                as={RouterLink}
                to="/support"
                display="flex"
                alignItems="center"
                gap={2}>
                <FiPhoneCall />
                {t("common.footer.support")}
              </Link>
            </VStack>
          </GridItem>
          {/* Resources Column */}
          <GridItem>
            <VStack align="flex-start" spacing={3} fontFamily="heading">
              <Heading size="md" fontWeight="bold" mb={2}>
                {t("common.footer.resources")}
              </Heading>
              <Link
                href="https://blog.araria.com.br/blog"
                display="flex"
                alignItems="center"
                gap={2}>
                <FiList />
                {t("common.footer.blog")}
              </Link>
              <Link
                as={RouterLink}
                to="/soon"
                display="flex"
                alignItems="center"
                gap={2}>
                <FiHelpCircle />
                {t("common.footer.documentation")}
              </Link>
              <Link
                // as={RouterLink}
                // to="/soon"
                href="https://prod-api.araria.com.br/api"
                display="flex"
                alignItems="center"
                gap={2}>
                <FiCode />
                {t("common.footer.api")}
              </Link>
              <Link
                href="https://github.com/ArariaBR"
                display="flex"
                alignItems="center"
                gap={2}>
                <FaGithub />
                {t("common.footer.github")}
              </Link>
            </VStack>
          </GridItem>
        </Grid>

        <Box
          pt={8}
          mt={8}
          borderTop="1px"
          borderColor={colorMode === "dark" ? "gray.700" : "gray.200"}>
          <HStack justify="space-between" fontSize="sm">
            <Text color={colorMode === "dark" ? "gray.400" : "gray.600"}>
              {t("common.footer.copyright", { year: new Date().getFullYear() })}
            </Text>
            <HStack spacing={4}>
              <Link as={RouterLink} to="/privacy-policy">
                {t("common.footer.privacy")}
              </Link>
              <Link as={RouterLink} to="/terms-of-service">
                {t("common.footer.terms")}
              </Link>
              <Link as={RouterLink} to="/account-deletion">
                {t("common.footer.accountDeletion")}
              </Link>
            </HStack>
          </HStack>
        </Box>
      </Container>
    </Box>
  );
};
